import {color} from "echarts";

const customStyles = {
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "DM Sans",
    color: "#fff",
  }),
  control: (provided) => ({
    ...provided,
    fontFamily: "DM Sans",
    color: "#fff",
    width: "100%",
    height: 48,
    borderRadius: 32,
    background: "var(--white-10, rgba(255, 255, 255, 0.10))",
    border: "1px solid #e1e4e2",
    cursor: "pointer",

    paddingRight: "20px",
    paddingLeft: "10px",

    fontSize: "14px",
    fontWeight: 500,
  }),
  option: (styles, {isFocused, isSelected}) => {
    return {
      ...styles,
      paddingLeft: 20,
      color: isSelected ? "#111512" : "#fff",
      backgroundColor: isSelected ? "#36D66B" : "#0f0f0f",
      border: "none",
      paddingTop: 10,
      paddingBottom: 10,
      marginTop: 0,
      marginBottom: 0,
      borderRadius: 0,
      cursor: "pointer",
      "&:hover": {
        borderColor: "#A4A8AE",
        backgroundColor: "#7ed69b",
        color: "white",
      },
    };
  },
  menu: (provided) => ({
    ...provided,
    maxHeight: "max-content", // Corrected capitalization
    borderRadius: 0, // Corrected to camelCase
    border: "1px solid var(--brand-primary, #36D66B)", // Proper CSS syntax
    background: "#0f0f0f", // Proper CSS syntax
    boxShadow: "0px 4px 7px 0px #12121A", // Proper CSS syntax
    backdropFilter: "blur(100px)", // Corrected to camelCase
    zIndex: 50, // Removed "!important" since it's not valid here
    overflow: "hidden", // Proper CSS syntax
    padding: 0,
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#fff",
  }),
};
export default customStyles;

export const customStyles2 = {
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: "#fff",
  }),

  control: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: "#ffffff",
    width: "100%",
    height: 48,
    borderRadius: 40,
    cursor: "pointer",
    border: "1px solid var(--box-1, rgba(54, 214, 107, 0.06))",
    background: "var(--box-1, rgba(54, 214, 107, 0.06))",
    paddingRight: "20px",
    paddingLeft: "10px",
    fontSize: "14px",
    fontWeight: 500,
  }),

  option: (styles, {isFocused, isSelected}) => {
    return {
      ...styles,
      paddingLeft: 20,
      color: isSelected ? "#000" : "#fff",
      backgroundColor: isSelected ? "#36d66b" : isFocused ? "#7ed69b" : "#0f0f0f",
      borderRadius: 0,
      paddingTop: 10,
      paddingBottom: 10,
      marginBottom: 0,
      marginTop: 0,
      cursor: "pointer",
      fontFamily: "Space Grotesk",
      textAlign: "center",
      "&:hover": {
        borderColor: "#A4A8AE",
        backgroundColor: "#7ed69b",
        color: "white",
        borderRadius: 0,
      },
    };
  },

  menu: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    maxHeight: "maxContent",
    borderRadius: 0,
    border: "1px solid var(--brand-primary, #36D66B)",
    background: "#0f0f0f",
    boxShadow: "0px 4px 7px 0px #12121A",
    backdropFilter: "blur(100px)",
    zIndex: "50 !important",
    overflow: "hidden",
    color: "#fff",
    padding: 0,
    gap: 0,
    width: "188px",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#fff",
  }),
};

export const customStyles3 = {
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: "#fff",
  }),

  control: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: "#ffffff",
    width: "fit-conetent",
    height: 48,
    borderRadius: 40,
    cursor: "pointer",
    border: "none",
    background: "transparent",
    fontSize: "14px",
    fontWeight: 500,
    maxWidth: "150px",
  }),

  option: (styles, {isFocused, isSelected}) => {
    return {
      ...styles,
      paddingLeft: 20,
      color: isSelected ? "#000" : "#fff",
      backgroundColor: isSelected ? "#36d66b" : isFocused ? "#7ed69b" : "#0f0f0f",
      borderRadius: 0,
      paddingTop: 10,
      paddingBottom: 10,
      marginBottom: 0,
      marginTop: 0,
      cursor: "pointer",
      fontFamily: "Space Grotesk",
      textAlign: "center",
      "&:hover": {
        borderColor: "#A4A8AE",
        backgroundColor: "#7ed69b",
        color: "white",
        borderRadius: 0,
      },
    };
  },

  menu: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    maxHeight: "maxContent",
    borderRadius: 0,
    border: "1px solid var(--brand-primary, #36D66B)",
    background: "#0f0f0f",
    boxShadow: "0px 4px 7px 0px #12121A",
    backdropFilter: "blur(100px)",
    zIndex: "50 !important",
    overflow: "hidden",
    color: "#fff",
    padding: 0,
    gap: 0,
    width: "188px",
  }),
  indicatorSeparator: () => ({
    display: "none", // Hides the separator
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#fff",
  }),
};

const newCustomStyles = (height = 31, color = "#fff", inputcolor = "#fff", maxHeight = "300px") => ({
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: color,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 20px)",
    fontSize: 20,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 1,
    background: "transparent !important",
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: color,
    width: "100%",
    borderRadius: 10,
    border: state.isFocused ? "1px solid transparent !important" : "1px solid transparent !important",
    background: "none",
    cursor: "pointer",
    marginLeft: 0,
    paddingRight: "0px",
    paddingLeft: "0px",
    outline: "none !important",
    boxShadow: "none !important",
    height: `${height}px`, // Overall height
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    marginLeft: 0,
    padding: "0 0px", // Add some padding for alignment
    // backgroundColor: bgColor,
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0 !important",
    padding: "0 !important",
    // backgroundColor: state.isFocused ? "transparent !important" : `${bgColor} !important`,
    color: `${color} !important`,
    border: "none !important",
    boxShadow: "none !important",
  }),
  option: (styles, {isFocused, isSelected}) => ({
    ...styles,
    color: isSelected ? "#071E0D" : "#fff",
    backgroundColor: isSelected ? "#36D66B" : isFocused ? "transparent" : "#0f0f0f",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 40,
    maxHeight: 40,
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 0,
    minWidth: 168,
    marginTop: 0,
    textWrap: "nowrap",
    borderRadius: 0,
    cursor: "pointer",
    textAlign: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "#36D66B",
      color: "#071E0D",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#0f0f0f",
    border: "none",
    zIndex: "99 !important",
    overflow: "auto",
    width: "max-content",
    minWidth: "100%",
    maxHeight: maxHeight,
    // maxWidth: "fit-content",
    padding: 0,
    paddingTop: 0,
    textWrap: "nowrap",
    paddingBottom: 0,
    borderRadius: 0,
    fontFamily: "Space Grotesk",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    left: "50%",
    right: "auto",
    transform: "translateX(-50%)",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    textAlign: "center",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    height: `${height}px`, // Adjust to match control height
    display: "flex",
    alignItems: "center",
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  }),
  indicatorSeparator: () => ({
    display: "none", // Hides the separator
  }),
});
export const cryptoNewCustomStyles = (height = 31, color = "#fff", inputcolor = "#fff", maxHeight = "300px") => ({
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: color,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 20px)",
    fontSize: 20,
    textTransform: "capitalize",
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 1,
    background: "transparent !important",
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: color,
    width: "100%",
    borderRadius: 10,
    border: state.isFocused ? "1px solid transparent !important" : "1px solid transparent !important",
    background: "none",
    cursor: "pointer",
    marginLeft: 0,
    paddingRight: "0px",
    textTransform: "capitalize",
    paddingLeft: "0px",
    outline: "none !important",
    boxShadow: "none !important",
    height: `${height}px`, // Overall height
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    marginLeft: 0,
    textTransform: "capitalize",
    padding: "0 0px", // Add some padding for alignment
    // backgroundColor: bgColor,
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0 !important",
    padding: "0 !important",
    textTransform: "capitalize",
    // backgroundColor: state.isFocused ? "transparent !important" : `${bgColor} !important`,
    color: `${color} !important`,
    border: "none !important",
    boxShadow: "none !important",
  }),
  option: (styles, {isFocused, isSelected}) => ({
    ...styles,
    color: isSelected ? "#121115" : "#fff",
    backgroundColor: isSelected ? "#FCD535" : "#0f0f0f",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "capitalize",
    height: 40,
    maxHeight: 40,
    paddingLeft: 20,
    paddingRight: 20,
    marginBottom: 0,
    minWidth: 168,
    marginTop: 0,
    textWrap: "nowrap",
    borderRadius: 0,
    cursor: "pointer",
    textAlign: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "#FCD535",
      color: "#121115",
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#0f0f0f",
    border: "none",
    zIndex: "99 !important",
    textTransform: "capitalize",
    overflow: "auto",
    width: "max-content",
    minWidth: "100%",
    maxHeight: maxHeight,
    // maxWidth: "fit-content",
    minWidth: 188,
    padding: 0,
    paddingTop: 0,
    textWrap: "nowrap",
    paddingBottom: 0,
    borderRadius: 0,
    fontFamily: "Space Grotesk",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    left: "50%",
    right: "auto",
    transform: "translateX(-50%)",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    textAlign: "center",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    height: `${height}px`, // Adjust to match control height
    display: "flex",
    alignItems: "center",
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  }),
  indicatorSeparator: () => ({
    display: "none", // Hides the separator
  }),
});

export const newSelectorStyles = (height = 31, color = "#fff", inputcolor = "#fff", maxHeight = "300px") => ({
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "DM Sans",
    color: color,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 20px)",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    height: `${height}px - 1`,
    zIndex: 1,
    textTransform: "capitalize",
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: color,
    width: "100%",
    borderRadius: 20,
    border: state.isFocused ? "1px solid transparent !important" : "1px solid transparent !important",
    cursor: "pointer",
    marginLeft: 0,
    paddingRight: "0px",
    paddingLeft: "0px",
    outline: "none !important",
    boxShadow: "none !important",
    height: `${height}px - 1`,
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 0,
    background: "rgba(255, 255, 255, 0.10)",
  }),
  valueContainer: (provided) => ({
    ...provided,
    marginLeft: 0,
    padding: "0 0 0 20px",
    // background: "rgba(255, 255, 255, 0.10)",
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0 !important",
    padding: "0 !important",
    color: `${color} !important`,
    border: "none !important",
    boxShadow: "none !important",
    // background: "rgba(255, 255, 255, 0.10)",
  }),
  option: (styles, {isFocused, isSelected}) => ({
    ...styles,
    color: isSelected ? "#071E0D" : "#fff",
    backgroundColor: isSelected ? "#36D66B" : isFocused ? "#152C1B" : "#0f0f0f",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "15px",
    borderRadius: "var(--button-corner-radius, 40px)",
    minHeight: 40,
    padding: "10px 15px",
    marginBottom: 0,
    minWidth: 168,
    marginTop: 0,
    whiteSpace: "normal",
    wordWrap: "break-word",
    borderRadius: 0,
    cursor: "pointer",
    textAlign: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    border: "1px solid var(--box-1, rgba(54, 214, 107, 0.06))",
    // background: "var(--Nav-BG, #152C1B)",
    "&:hover": {
      backgroundColor: "#36D66B",
      color: "#071E0D",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: "100 !important",
    overflow: "auto",
    width: "100%",
    maxHeight: maxHeight,
    maxWidth: "100%",
    minWidth: 188,
    padding: 0,
    paddingTop: 0,
    textWrap: "nowrap",
    paddingBottom: 0,
    fontFamily: "Space Grotesk",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    display: "flex",
    flexDirection: "column",
    gap: 0,
    borderRadius: "0px",
    border: "1px solid #36D66B",
    background: "#0f0f0f",
    boxShadow: "0px 4px 7px 0px #12121A",
    backdropFilter: "blur(100px)",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: maxHeight,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    height: `${height}px`, // Adjust to match control height
    display: "flex",
    alignItems: "center",
    paddingRight: "20px",
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  }),
  indicatorSeparator: () => ({
    display: "none", // Hides the separator
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: "#fff", // text color
    padding: "10px",
    textAlign: "center",
  }),
});
export const newCryptoSelectorStyles = (height = 31, color = "#fff", inputcolor = "#fff", maxHeight = "300px") => ({
  singleValue: (provided) => ({
    ...provided,
    fontFamily: "DM Sans",
    color: color,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 20px)",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    height: `${height}px - 1`,
    zIndex: 1,
    textTransform: "capitalize",
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: "Space Grotesk",
    color: color,
    width: "100%",
    borderRadius: 20,
    border: state.isFocused ? "1px solid transparent !important" : "1px solid transparent !important",
    cursor: "pointer",
    marginLeft: 0,
    paddingRight: "0px",
    paddingLeft: "0px",
    outline: "none !important",
    boxShadow: "none !important",
    height: `${height}px - 1`,
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,
    zIndex: 0,
    background: "rgba(255, 255, 255, 0.10)",
  }),
  valueContainer: (provided) => ({
    ...provided,
    marginLeft: 0,
    padding: "0 7px 0 20px",
    // background: "rgba(255, 255, 255, 0.10)",
  }),
  input: (provided, state) => ({
    ...provided,
    margin: "0 !important",
    padding: "0 !important",
    color: `${color} !important`,
    border: "none !important",
    boxShadow: "none !important",
    // background: "rgba(255, 255, 255, 0.10)",
  }),
  option: (styles, {isFocused, isSelected}) => ({
    ...styles,
    color: isSelected ? "#121115" : isFocused ? "#fff" : "#fff",
    backgroundColor: isSelected ? "#FCD535" : isFocused ? "rgba(255, 255, 255, 0.05)" : "#0f0f0f",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0,
    minHeight: 40,
    padding: "10px 15px",
    marginBottom: 0,
    minWidth: 168,
    marginTop: 0,
    whiteSpace: "normal",
    wordWrap: "break-word",
    borderRadius: 0,
    cursor: "pointer",
    textAlign: "center",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    border: "1px solid rgba(65, 65, 65, 0.50)",
    "&:hover": {
      backgroundColor: "#FCD535",
      color: "#121115",
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: "100 !important",
    overflow: "auto",
    width: "100%",
    maxHeight: maxHeight,
    maxWidth: "100%",
    minWidth: 188,
    padding: 0,
    paddingTop: 0,
    textWrap: "nowrap",
    paddingBottom: 0,
    fontFamily: "Space Grotesk",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 700,
    display: "flex",
    flexDirection: "column",
    gap: 0,
    borderRadius: 0,
    backgroundColor: "#0f0f0f",
    border: "none",
    boxShadow:
      "0px 68px 19px 0px rgba(0, 0, 0, 0.05), 0px 44px 17px 0px rgba(0, 0, 0, 0.02), 0px 25px 15px 0px rgba(0, 0, 0, 0.08), 0px 11px 11px 0px rgba(0, 0, 0, 0.13), 0px 3px 6px 0px rgba(0, 0, 0, 0.15)",
    backdropFilter: "blur(100px)",
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: maxHeight,
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    height: `${height}px`, // Adjust to match control height
    display: "flex",
    alignItems: "center",
    paddingRight: "20px",
    color: "#fff",
    "&:hover": {
      color: "#fff",
    },
  }),
  indicatorSeparator: () => ({
    display: "none", // Hides the separator
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: "#fff", // text color
    padding: "10px",
    textAlign: "center",
  }),
});

export {newCustomStyles};
